import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import BookingForm from "../components/BookingForm";
import "../styles/CloudKitchen.css";

/* ======================================================
   DAILY FOODS MENUS
====================================================== */

const cloudKitchenMenus = [
  {
    id: "daily-foods-without-rice",
    name: "Daily Foods Without Rice",
    type: "Without Rice",
    description:
      "Sambaar, Rasam, Curry and Koottu.",
    pricePerPerson: 160,
  },

  {
    id: "daily-foods-with-rice",
    name: "Daily Foods With Rice",
    type: "With Rice",
    description:
      "Sambaar, Rasam, Curry, Koottu, Rice and Butter Milk.",
    pricePerPerson: 210,
  },
];

/* ======================================================
   COMPONENT
====================================================== */

const CloudKitchen = () => {
  const location = useLocation();

  const [selectedMenu, setSelectedMenu] = useState(null);

  /* ======================================================
     HANDLE DEEP LINK FROM HOME
  ====================================================== */

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const type = params.get("type");

    const menuId = params.get("menu");

    if (type !== "cloud-kitchen") return;

    const matchedMenu = cloudKitchenMenus.find(
      (m) => m.id === menuId
    );

    setSelectedMenu(
      matchedMenu || cloudKitchenMenus[0]
    );

    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }, 300);
  }, [location.search]);

  /* ======================================================
     HANDLE ORDER
  ====================================================== */

  const handleOrder = (menu) => {
    setSelectedMenu(menu);

    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  };

  /* ======================================================
     RENDER
  ====================================================== */

  return (
    <motion.div
      className="cloud-kitchen-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      {/* ======================================================
          HEADER
      ====================================================== */}

      <header className="cloud-header">
        <h2>🍱 Daily Foods</h2>

        <p className="cloud-intro">
          Freshly prepared home-style South Indian meals cooked daily
          with hygienic ingredients and authentic traditional taste.
          Perfect for individuals, families and daily food needs.
        </p>
      </header>

      {/* ======================================================
          MENU GRID
      ====================================================== */}

      <section className="cloud-menu-grid">
        {cloudKitchenMenus.map((menu) => (
          <div className="cloud-menu-card" key={menu.id}>
            <div className="cloud-menu-header">
              <h3>{menu.name}</h3>

              <span className="cloud-menu-type">
                {menu.type}
              </span>
            </div>

            <p className="cloud-menu-desc">
              {menu.description}
            </p>

            <p className="cloud-price">
              ₹{menu.pricePerPerson} / person
            </p>

            <button
              className="cloud-order-btn"
              onClick={() => handleOrder(menu)}
            >
              Order This Meal
            </button>
          </div>
        ))}
      </section>

      {/* ======================================================
          ORDER FORM
      ====================================================== */}

      {selectedMenu && (
        <section className="cloud-booking-wrapper">
          <h3>📋 Order: {selectedMenu.name}</h3>

          <BookingForm
            type="Cloud Kitchen"
            menuName={selectedMenu.name}
            price={selectedMenu.pricePerPerson}
          />
        </section>
      )}
    </motion.div>
  );
};

export default CloudKitchen;